// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListArrow_wrapper__1dR6j","header":"ListArrow_header__1CX4q","left":"ListArrow_left__3g2dl","right":"ListArrow_right__8VDgB"};